<script setup lang="ts">
withDefaults(
  defineProps<{
    description?: string
    howToGetThere?: string
    seoFeaturedPhotoDescription?: string
    seoPhotoUrl?: string
    title?: string
    whenToLeaveText?: string
  }>(),
  {
    description: '',
    howToGetThere: '',
    seoFeaturedPhotoDescription: '',
    seoPhotoUrl: '',
    title: '',
    whenToLeaveText: '',
  },
)
</script>

<template>
  <section>
    <div class="relative pt-12 md:pt-20 lg:pt-36">
      <div class="absolute top-0 size-full bg-gray-700" />
      <BaseContainer>
        <BaseRow>
          <BaseCol cols="24" lg="8">
            <h2 class="mb-6 text-center text-white md:text-8xl lg:text-left">
              {{ title }}
            </h2>
          </BaseCol>

          <BaseCol cols="24" lg="16">
            <div class="mb-8 text-white lg:pl-6" v-html="description" />
          </BaseCol>
        </BaseRow>
      </BaseContainer>
    </div>

    <div v-if="!!seoPhotoUrl" class="relative">
      <div class="desti-about-block--img-background" />
      <BaseContainer>
        <BaseRow>
          <BaseCol cols="24">
            <BaseNuxtImg
              :src="seoPhotoUrl"
              :alt="seoFeaturedPhotoDescription || title"
              width="1232"
              height="600"
              class="desti-about-block--img"
            />
          </BaseCol>
        </BaseRow>
      </BaseContainer>
    </div>

    <BaseContainer v-if="!!howToGetThere || !!whenToLeaveText">
      <BaseRow>
        <BaseCol
          v-if="!!whenToLeaveText"
          :md="howToGetThere ? '12' : '24'"
          cols="24"
          class="desti-about-block--info-col"
        >
          <h3 class="desti-about-block--subtitle">
            {{ $t('destination.when_to_leave') }}
          </h3>
          <div class="desti-about-block--info" v-html="whenToLeaveText" />
        </BaseCol>

        <BaseCol
          v-if="!!howToGetThere"
          :md="whenToLeaveText ? '12' : '24'"
          cols="24"
          class="desti-about-block--info-col"
        >
          <h3 class="desti-about-block--subtitle">
            {{ $t('destination.how_to_get_there') }}
          </h3>
          <div class="desti-about-block--info" v-html="howToGetThere" />
        </BaseCol>
      </BaseRow>
    </BaseContainer>
  </section>
</template>

<style>
.desti-about-block--img {
  @apply w-full;
  height: 300px;
}

.desti-about-block--info-col ul {
  @apply pl-4 list-disc;
}
.desti-about-block--info-col strong {
  @apply font-bold;
}
@screen md {
  .desti-about-block--img {
    height: 400px;
  }
}

@screen lg {
  .desti-about-block--img {
    height: 600px;
  }
}

.desti-about-block--img-background {
  height: 30%;
  top: -2px;
  @apply bg-gray-700 absolute w-full;
}

@screen md {
  .desti-about-block--info-col {
    @apply pr-12;
  }
}

.desti-about-block--subtitle {
  @apply text-center mt-8 mb-4;
}

@screen md {
  .desti-about-block--subtitle {
    @apply text-left;
  }
}

.desti-about-block--info blockquote p {
  padding: 1.5rem 0 0 1rem;
}

.desti-about-block--info blockquote:before {
  @apply absolute text-gray-700;
}
</style>
